import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './assets/css/employee.css';

// Context Providers
import { AuthProvider } from './context/AuthContext';
import { WRMSProvider } from './wrms/context/WRMSContext';

// WRMS Pages
import WRMSLandingPage from './wrms/pages/WRMSLandingPage';
import LeaveRequestPage from './wrms/pages/LeaveRequestPage';
import EarlyLeavePage from './wrms/pages/EarlyLeavePage';
import GatePassPage from './wrms/pages/GatePassPage';
import ExtraWorkPage from './wrms/pages/ExtraWorkPage';
import RequestDetailPage from './wrms/pages/RequestDetailPage';
import ApprovalsInboxPage from './wrms/pages/ApprovalsInboxPage';
import HRAdminPanelPage from './wrms/pages/HRAdminPanelPage';
import WRMSReportsPage from './wrms/pages/WRMSReportsPage';

// Pages
import Login from './pages/Login';
// import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import DashboardPage from './pages/DashboardPage';
import EmployeePage from './pages/EmployeePage';
import EmployeeListPage from './pages/EmployeeListPage';
import AddEmployeePage from './pages/AddEmployeePage';
import EmployeeProfilePage from './pages/EmployeeProfilePage';
import EditEmployeePage from './pages/EditEmployeePage';
import AttendancePage from './pages/AttendancePage';
// LeavePage replaced by WRMS Leave Management
// import LeavePage from './pages/LeavePage';
// import PayrollPage from './pages/PayrollPage';
import ReminderPage from './pages/ReminderPage';
import ReportsPage from './pages/ReportsPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import DepartmentsPage from './pages/DepartmentsPage';
import MyProfilePage from './pages/MyProfilePage';
import NotFound from './pages/NotFound';

// Route Protection
import PrivateRoute from './routes/PrivateRoute';

function App() {
    return (
        <AuthProvider>
            <WRMSProvider>
                <Router>
                    <div className="App">
                        <Routes>
                            {/* Public Routes */}
                            <Route path="/login" element={<Login />} />
                            {/* Register route disabled for security - only admin can create accounts */}
                            {/* <Route path="/register" element={<Register />} /> */}
                            <Route path="/forgot-password" element={<ForgotPassword />} />

                            {/* Protected Routes */}
                            <Route path="/" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
                            <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
                            <Route path="/employees" element={<PrivateRoute><EmployeeListPage /></PrivateRoute>} />
                            <Route path="/employees/add" element={<PrivateRoute><AddEmployeePage /></PrivateRoute>} />
                            <Route path="/employees/:id" element={<PrivateRoute><EmployeeProfilePage /></PrivateRoute>} />
                            <Route path="/employees/:id/edit" element={<PrivateRoute><EditEmployeePage /></PrivateRoute>} />
                            <Route path="/employees/old" element={<PrivateRoute><EmployeePage /></PrivateRoute>} />
                            <Route path="/attendance" element={<PrivateRoute><AttendancePage /></PrivateRoute>} />
                            <Route path="/leaves" element={<PrivateRoute><WRMSLandingPage /></PrivateRoute>} />
                            {/* <Route path="/payroll" element={<PrivateRoute><PayrollPage /></PrivateRoute>} /> */}
                            <Route path="/reminders" element={<PrivateRoute><ReminderPage /></PrivateRoute>} />
                            <Route path="/reports" element={<PrivateRoute><ReportsPage /></PrivateRoute>} />
                            <Route path="/departments" element={<PrivateRoute><DepartmentsPage /></PrivateRoute>} />
                            <Route path="/my-profile" element={<PrivateRoute><MyProfilePage /></PrivateRoute>} />
                            <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
                            <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />

                            {/* ── WRMS — Workforce Request Management System ── */}
                            <Route path="/wrms" element={<PrivateRoute><WRMSLandingPage /></PrivateRoute>} />
                            <Route path="/wrms/leave-request" element={<PrivateRoute><LeaveRequestPage /></PrivateRoute>} />
                            <Route path="/wrms/early-leave" element={<PrivateRoute><EarlyLeavePage /></PrivateRoute>} />
                            <Route path="/wrms/gate-pass" element={<PrivateRoute><GatePassPage /></PrivateRoute>} />
                            <Route path="/wrms/extra-work" element={<PrivateRoute><ExtraWorkPage /></PrivateRoute>} />
                            <Route path="/wrms/request/:type/:id" element={<PrivateRoute><RequestDetailPage /></PrivateRoute>} />
                            <Route path="/wrms/approvals" element={<PrivateRoute><ApprovalsInboxPage /></PrivateRoute>} />
                            <Route path="/wrms/admin" element={<PrivateRoute><HRAdminPanelPage /></PrivateRoute>} />
                            <Route path="/wrms/reports" element={<PrivateRoute><WRMSReportsPage /></PrivateRoute>} />

                            {/* Direct Aliases */}
                            <Route path="/leave-request" element={<PrivateRoute><LeaveRequestPage /></PrivateRoute>} />
                            <Route path="/early-leave" element={<PrivateRoute><EarlyLeavePage /></PrivateRoute>} />
                            <Route path="/gate-pass" element={<PrivateRoute><GatePassPage /></PrivateRoute>} />
                            <Route path="/gatepass" element={<PrivateRoute><GatePassPage /></PrivateRoute>} />
                            <Route path="/extra-work" element={<PrivateRoute><ExtraWorkPage /></PrivateRoute>} />
                            <Route path="/approvals" element={<PrivateRoute><ApprovalsInboxPage /></PrivateRoute>} />

                            {/* 404 */}
                            <Route path="*" element={<NotFound />} />
                        </Routes>

                        <ToastContainer
                            position="top-right"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </div>
                </Router>
            </WRMSProvider>
        </AuthProvider>
    );
}

export default App;
